import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_sales_lead_hdr_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  stage_guid: fromDatatype.GuidDataFieldInterface;
  type_guid: fromDatatype.GuidDataFieldInterface;
  organization_guid: fromDatatype.GuidDataFieldInterface;
  phone: fromDatatype.TextDatatypeInterface;
  email: fromDatatype.TextDatatypeInterface;
  firstname: fromDatatype.TextDatatypeInterface;
  lastname: fromDatatype.TextDatatypeInterface;
  probability: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  ethnicity: fromDatatype.VarcharDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  region_code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
  last_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  next_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  target_start_date: fromDatatype.TimestampTzDatatypeInterface;
  target_end_date: fromDatatype.TimestampTzDatatypeInterface;
  contact_type: fromDatatype.VarcharDatatypeInterface;
  rating_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  reporter: fromDatatype.GuidDataFieldInterface;
  assignee: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  category_0_guid: fromDatatype.GuidDataFieldInterface;
  category_1_guid: fromDatatype.GuidDataFieldInterface;
  category_2_guid: fromDatatype.GuidDataFieldInterface;
  category_3_guid: fromDatatype.GuidDataFieldInterface;
  category_4_guid: fromDatatype.GuidDataFieldInterface;
  category_5_guid: fromDatatype.GuidDataFieldInterface;
  category_6_guid: fromDatatype.GuidDataFieldInterface;
  category_7_guid: fromDatatype.GuidDataFieldInterface;
  category_8_guid: fromDatatype.GuidDataFieldInterface;
  category_9_guid: fromDatatype.GuidDataFieldInterface;
  category_10_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_sfa_sales_lead_hdr_RowClass implements bl_sfa_sales_lead_hdr_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  stage_guid: fromDatatype.GuidDataFieldInterface;
  type_guid: fromDatatype.GuidDataFieldInterface;
  organization_guid: fromDatatype.GuidDataFieldInterface;
  phone: fromDatatype.TextDatatypeInterface;
  email: fromDatatype.TextDatatypeInterface;
  firstname: fromDatatype.TextDatatypeInterface;
  lastname: fromDatatype.TextDatatypeInterface;
  probability: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  ethnicity: fromDatatype.VarcharDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  region_code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
  last_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  next_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  target_start_date: fromDatatype.TimestampTzDatatypeInterface;
  target_end_date: fromDatatype.TimestampTzDatatypeInterface;
  contact_type: fromDatatype.VarcharDatatypeInterface;
  rating_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  reporter: fromDatatype.GuidDataFieldInterface;
  assignee: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  category_0_guid: fromDatatype.GuidDataFieldInterface;
  category_1_guid: fromDatatype.GuidDataFieldInterface;
  category_2_guid: fromDatatype.GuidDataFieldInterface;
  category_3_guid: fromDatatype.GuidDataFieldInterface;
  category_4_guid: fromDatatype.GuidDataFieldInterface;
  category_5_guid: fromDatatype.GuidDataFieldInterface;
  category_6_guid: fromDatatype.GuidDataFieldInterface;
  category_7_guid: fromDatatype.GuidDataFieldInterface;
  category_8_guid: fromDatatype.GuidDataFieldInterface;
  category_9_guid: fromDatatype.GuidDataFieldInterface;
  category_10_guid: fromDatatype.GuidDataFieldInterface;

}
